import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { IconButton, Link, TextField } from "@mui/material";
import { red } from "@mui/material/colors";

import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import SlowMotionVideoRoundedIcon from "@mui/icons-material/SlowMotionVideoRounded";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#2D383C",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const PhysicsOffModal = ({ openRoutine, handleRoutineClose, routine }) => {
  const { Chapter, Subject, Pdf, ClassLink } = routine;
  return (
    <div>
      <Modal
        open={openRoutine}
        onClose={handleRoutineClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            sx={{ padding: "3px" }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            {Subject}

            <TextField
              sx={{
                width: "100%",
                padding: " 3x 5px",
                marginTop: "3px",
              }}
              label={Chapter}
              variant="filled"
              disabled
              color="success"
              focused
            />
          </Typography>

          <Box
            sx={{
              my: "10px",
              mt: "10px",
              display: "grid",
              // placeItems: "center",
              justifyContent: "center",
              gridGap: "100px",
              gridTemplateColumns: " 50px 50px",
            }}
          >
            <Link href={ClassLink} target="_blank" underline="none">
              <IconButton sx={{ bgcolor: red[300] }} size="large">
                <SlowMotionVideoRoundedIcon
                  sx={{ color: "white" }}
                ></SlowMotionVideoRoundedIcon>
              </IconButton>
            </Link>

            {Pdf ? (
              <Link href={Pdf} target="_blank" underline="none">
                <IconButton sx={{ bgcolor: red[300] }} size="large">
                  <PictureAsPdfRoundedIcon
                    sx={{ color: "white" }}
                  ></PictureAsPdfRoundedIcon>
                </IconButton>
              </Link>
            ) : (
              ""
            )}
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default PhysicsOffModal;
